import React, { Suspense, useEffect, useRef, useState } from 'react';
import { useRouter } from 'found';
import bgDesktop from 'assets/tiktok-bg-desktop.png';
import bgMobile from 'assets/tiktok-bg-mobile.png';
import tiktokTile from 'assets/tiktok-tile.png';
import { IconButton, useMediaQuery } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import PropTypes from 'prop-types';
import Main from 'ripple/Containers/Main';

// eslint-disable-next-line import/no-unresolved
const Activities = React.lazy(() => import('activities/Activities'));
const copyItems = (slug) => {
  let textItems;
  switch (slug) {
    case 'heinz57inviteonly':
    case 'heinz57':
      textItems = {
        enter: 'Enter to Win',
        prize: (mobile) => (
          <h1
            style={{
              height: mobile ? '6.5vw' : '70px',
              color: '#fff',
              fontSize: mobile ? '8vw' : '112px',
              margin: mobile ? '2.2vw auto 0' : '30px auto 15px',
              fontWeight: '700',
              paddingBottom: mobile ? 'initial' : 80,
              borderBottom: mobile ? 'none' : '3px solid #fff',
              letterSpacing: '-0.03em',
            }}
          >
            <small style={{ fontSize: mobile ? '5vw' : '72px' }}>$</small>1,000
          </h1>
        ),
        header: 'HEINZ 57 Collection TikTok Challenge',
        description: [
          'Get those culinary juices flowing! We want to see all the creative ways you’re showing off the new HEINZ 57 Collection. Submit your video for a chance to win a $1,000 cash prize. The more original your video, the greater your chance of winning some serious cash money. So grab your phone and get filming!',
        ],
        guideVideo: 'TikTokChallenge.mp4',
        guideType: 'video',
      };
      break;
    case 'canonivy2holiday':
      textItems = {
        enter: 'Enter to win a',
        prize: (mobile) => (
          <h1
            style={{
              height: mobile ? '8vw' : 120,
              color: '#fff',
              fontSize: mobile ? '4vw' : 50,
              margin: mobile ? '0 auto 1vw' : '0px auto 25px',
              fontWeight: '700',
              paddingBottom: mobile ? 'initial' : 125,
              borderBottom: mobile ? 'none' : '3px solid #fff',
              letterSpacing: '-0.03em',
              lineHeight: mobile ? '1em' : 'initial',
            }}
          >
            “Best of TikTok” Kit!
          </h1>
        ),
        header: 'Canon IVY 2 TikTok Giveaway',
        description: [
          <>Getting ready to deck the halls for the holidays? Canon wants to see how you’re using their new <strong>Canon IVY 2 Mini Photo Printer</strong> to make your holidays merry!</>,
          <>Submit your video using the activity tile below for your chance to win a special “Best of TikTok” kit which includes cool content creator tools like a ring light, green screen, photo props, and more! The more original your video, the greater your chances. So grab your phone and get filming!</>,
        ],
        guideVideo: 'CanonHoliday.mp4',
        guideType: 'video',
      };
      break;
    default:
      break;
  }
  return textItems;
};

const TiktokChallenge = ({ viewer }) => {
  const activitiesList = useRef(null);
  const { router } = useRouter();
  const mobile = useMediaQuery('(min-width:769px)');
  const tablet = useMediaQuery('(min-width:900px)');
  const { event } = viewer;
  const eventId = event.id;
  const sponsorId = event.community.id;
  const personId = viewer.person ? viewer.person.id : null;
  const [activitiesRendered, setActivitiesRendered] = useState(null);

  useEffect(() => {
    if (['heinz57inviteonly', 'heinz57', 'canonivy2holiday'].indexOf(event.slug) === -1) {
      router.push(`/events/${event.slug}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (personId) {
      if (activitiesList.current && !activitiesRendered) {
        setActivitiesRendered(
          <Suspense fallback='Loading Activities...'>
            <Activities context={{
                eventId,
                sponsorId,
                userId: personId,
                isOnlySpecial: true,
              }}
            />
          </Suspense>,
        );
      }
    }
  }, [activitiesRendered, eventId, personId, sponsorId]);
  const copyObj = copyItems(event.slug);

  return (
    <Main viewer={viewer} title={event.name}>
      {copyObj && (
        <div style={mobile ? {} : { paddingBottom: '10vh' }}>
          <img
            src={mobile ? bgDesktop : bgMobile}
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              height: mobile ? 'auto' : '1240px',
            }}
            alt='bg-desktop'
          />
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: mobile ? '32%' : '100%',
              padding: `80px ${mobile ? '2.8vw' : '7vw'} 2.8vw`,
            }}
          >
            <IconButton
              style={{
                maxWidth: '270px',
                height: mobile ? '2.5vw' : '40px',
                background: '#F48120',
                borderRadius: '60px',
                fontSize: mobile ? '1.1vw' : 'larger',
                fontWeight: '700',
              }}
              onClick={() => router.push(`/events/${event.slug}`)}
              size='large'
            >
              <ChevronLeft style={mobile ? { width: '1.5vw' } : {}} />
              Back to Event Page
            </IconButton>
            <h2
              style={{
                height: mobile ? '2.6vw' : '100%',
                color: '#fff',
                fontSize: mobile ? '2.3vw' : '28px',
                margin: mobile ? '1.75vw auto 0' : '25px auto 10px',
                fontWeight: '700',
              }}
            >
              {copyObj.enter}
            </h2>
            {copyObj.prize(mobile)}
            <h2
              style={{
                color: '#000',
                fontSize: mobile ? '2.3vw' : '30px',
                margin: '1.25vw auto',
                fontWeight: '700',
                lineHeight: mobile ? '2.5vw' : '34px',
              }}
            >
              {copyObj.header}
            </h2>
            {copyObj.description.map((msg) => (
              <p
                style={{
                  color: '#000',
                  fontSize: mobile ? '1.3vw' : '1rem',
                  margin: '1.25vw auto 2vw',
                  fontWeight: '500',
                  lineHeight: mobile ? '2vw' : '1.5rem',
                }}
              >
                {msg}
              </p>
            ))}
            <div
              ref={activitiesList}
              style={
                mobile
                  ? { backgroundColor: 'transparent' }
                  : {
                      position: 'absolute',
                      width: '100%',
                      top: '1240px',
                      left: '0px',
                      display: 'flex',
                      justifyContent: 'center',
                      padding: mobile ? '40px' : '40px 0 120px',
                      backgroundColor: '#0C152E',
                    }
              }
            >
              {activitiesRendered || (
                <img
                  style={
                    mobile
                      ? { width: '9vw', height: '9vw' }
                      : { width: '180px', height: '180px' }
                  }
                  src={tiktokTile}
                  alt='tile'
                />
              ) }
            </div>
          </div>
          <div
            style={{
              // eslint-disable-next-line no-nested-ternary
              ...(mobile
                ? { width: '24%', maxWidth: '45em', minWidth: '186px', maxHeight: '730px', minHeight: '400px', top: '13vw', left: '43%', fontSize: '1.3vw' }
                : (tablet ? { width: '50vw', maxWidth: '250px', minWidth: '150px', maxHeight: '730px', minHeight: '400px', top: '730px', left: '25vw' } : { width: '50vw', maxWidth: '370px', minWidth: '150px', maxHeight: '230px', minHeight: '400px', top: '730px', left: '25vw' })),
              position: 'absolute',
              color: '#fff',
              textAlign: 'center',
            }}
          >
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            {(copyObj.guideType === 'video') ? (
              <video controls width='100%' height={!mobile && !tablet ? '450px!important' : '100%'} autoPlay muted>
                <source src={`${process.env.CDN_URL}/website/special-activities/${copyObj.guideVideo}`} type='video/mp4' />
                <track />
              </video>
            ) : (
              <img
                width='100%'
                height={!mobile && !tablet ? '450px!important' : '100%'}
                alt={`${event.name} TikTok Challenge`}
                src={`${process.env.CDN_URL}/website/special-activities/${copyObj.guideVideo}`}
              />
            )}
          </div>
        </div>
      )}
    </Main>
  );
};

TiktokChallenge.propTypes = {
  viewer: PropTypes.object.isRequired,
};

export default TiktokChallenge;
